var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinsStacked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 3.3335C13.3334 4.43807 10.9456 5.3335 8.00008 5.3335C5.05456 5.3335 2.66675 4.43807 2.66675 3.3335M13.3334 3.3335C13.3334 2.22893 10.9456 1.3335 8.00008 1.3335C5.05456 1.3335 2.66675 2.22893 2.66675 3.3335M13.3334 3.3335V12.6668C13.3334 13.7714 10.9456 14.6668 8.00008 14.6668C5.05456 14.6668 2.66675 13.7714 2.66675 12.6668V3.3335M13.3334 6.44456C13.3334 7.54913 10.9456 8.44456 8.00008 8.44456C5.05456 8.44456 2.66675 7.54913 2.66675 6.44456M13.3334 9.5535C13.3334 10.6581 10.9456 11.5535 8.00008 11.5535C5.05456 11.5535 2.66675 10.6581 2.66675 9.5535",
    stroke: "#405BD8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsStacked);
export default __webpack_public_path__ + "static/media/coins-stacked.f682e57733e3c76b8640c487cd7b510b.svg";
export { ForwardRef as ReactComponent };